import moment from 'moment';
import Api from '../../../../shared/Api';

class MultiplePhotographersInvoiceApi {
    static getLists(): Promise<any> {
        return new Api().get('/views/photographer-invoice-collection/list');
    }

    static getInvoiceCollection(type: string): Promise<any> {
        return new Api().get(`/views/photographer-invoice-collection/${type}`);
    }

    static getHistoricInvoiceCollection(photographerInvoiceCollectionId: number): Promise<any> {
        return new Api().get(
            `/views/photographer-invoice-collection/historic/${photographerInvoiceCollectionId}`
        );
    }

    static savePendingInvoiceCollection(checksums: any): Promise<any> {
        return new Api().post('/views/photographer-invoice-collection/save', {
            checksums
        });
    }

    static createPaymentFile(collectionId: number, when?: Date): any {
        let querystring = when ? `?when=${moment(when).format('YYMMDD')}` : '';
        return new Api().downloadFile(
            `/views/photographer-invoice-collection/${collectionId}/file${querystring}`
        );
    }

    static createPaymentFileV2(collectionId: number, when?: Date): any {
        let querystring = when ? `?when=${moment(when).format('YYMMDD')}` : '';
        return new Api().downloadFile(
            `/views/photographer-invoice-collection/${collectionId}/fileV2${querystring}`
        );
    }

    static markOutlierAsReviewed(outlierId: number): Promise<void> {
        return new Api().put(`/views/photographer-invoice-collection/outliers/${outlierId}`, {
            markedAsReviewed: true
        });
    }
}

export default MultiplePhotographersInvoiceApi;
